import {
  IconCpu,
  IconPhoto,
  IconSchool,
  IconUserFilled,
  IconWaveSine,
} from '@tabler/icons-react';

const cores = {
  COGNITIVE_CORE: {
    icon: <IconUserFilled size={18} />,
  },
  VOICE_CORE: {
    icon: <IconWaveSine size={18} />,
  },
  VISUAL_CORE: {
    icon: <IconPhoto size={18} />,
  },
  DOMAIN_EXPERTISE_CORE: {
    icon: <IconSchool size={18} />,
  },
  MEMORY_CORE: {
    icon: <IconCpu size={18} />,
  },
};

export default cores;
